import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { STATUS_META, StatusKey } from '../../types';
const ORDER: StatusKey[] = ['not_started', 'working', 'stuck', 'done', 'na'];
export function StatusPill({
  status
}: {
  status: StatusKey;
}) {
  const m = STATUS_META[status];
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${m.bg} ${m.text}`} data-id="element-22" data-mp="h06tvd6ohm0g">
      <span className={`h-1.5 w-1.5 rounded-full ${m.dot}`} data-id="element-23" data-mp="380gfyuwtt4p" />
      {m.label}
    </span>;
}
export function StatusSelect({
  status,
  onChange
}: {
  status: StatusKey;
  onChange: (s: StatusKey) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  const m = STATUS_META[status];
  return <div className="relative" ref={ref} data-id="element-24" data-mp="1vvb3ak44gt3l">
      <button onClick={() => setOpen(o => !o)} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold transition hover:opacity-90 ${m.bg} ${m.text}`} data-id="element-25" data-mp="1vuj6x72parc9">
        <span className={`h-1.5 w-1.5 rounded-full ${m.dot}`} data-id="element-26" data-mp="24winxzdptvf7" />
        {m.label}
        <ChevronDownIcon className="h-3 w-3 opacity-70" data-id="element-27" data-mp="1h7g72tqwo6lr" />
      </button>
      {open && <div className="absolute z-20 mt-1 w-40 overflow-hidden rounded-lg border border-slate-200 bg-white py-1 shadow-pop" data-id="element-28" data-mp="1c8d3ldqkq8fw">
          {ORDER.map(key => {
        const mm = STATUS_META[key];
        return <button key={key} onClick={() => {
          onChange(key);
          setOpen(false);
        }} className="flex w-full items-center gap-2 px-3 py-1.5 text-left text-xs font-medium text-slate-700 hover:bg-slate-50" data-id="element-29" data-mp="1m3wzw191v956">
                <span className={`h-2 w-2 rounded-full ${mm.dot}`} data-id="element-30" data-mp="2tgz9slgvue0r" />
                {mm.label}
              </button>;
      })}
        </div>}
    </div>;
}